import React, { useState, useEffect, useRef } from "react";
import { DownOutlined } from "@ant-design/icons";

// Compact title picker for the card face. The native select popup is drawn by the
// browser and cannot be sized, so this renders its own small list.
const SalutationPicker = ({ value, options, onChange, label, emptyLabel }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onPointerDown = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onPointerDown);
        return () => document.removeEventListener("mousedown", onPointerDown);
    }, [open]);

    const choose = (next) => {
        setOpen(false);
        if (next !== value) onChange(next);
    };

    return (
        <div
            ref={rootRef}
            className="relative shrink-0"
            onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
        >
            <button
                type="button"
                aria-label={label}
                aria-haspopup="listbox"
                aria-expanded={open}
                onClick={() => setOpen(!open)}
                className="flex items-center gap-1 h-6 px-2 rounded-full bg-white/15 hover:bg-white/25 text-xs text-white transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-white/70"
            >
                <span>{value || emptyLabel}</span>
                <DownOutlined className={`text-[8px] transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <ul
                    role="listbox"
                    aria-label={label}
                    className="absolute start-0 top-full mt-1 z-20 min-w-full w-max py-1 rounded-lg bg-white shadow-lg ring-1 ring-black/5 text-xs text-gray-700 text-start"
                >
                    {["", ...options].map((x) => (
                        <li
                            key={x || "empty"}
                            role="option"
                            aria-selected={x === (value || "")}
                            tabIndex={0}
                            onClick={() => choose(x)}
                            onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), choose(x))}
                            className={`px-3 py-1 cursor-pointer hover:bg-indigo-50 ${x === (value || "") ? "font-semibold text-indigo-700" : ""} ${x === "" ? "text-gray-400" : ""}`}
                        >
                            {x || emptyLabel}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SalutationPicker;
